export default {
  '': {
    imageLink:
      'link',
    tags: [
      'React',
      'Redux',
      'Node.js',
      'PostgreSQL',
      'Redis',
      'AWS',
    ],
    title: '',
    description: '',
    link: 'link',
  },
  hap: {
    imageLink:
      'link',
    tags: ['Vue.js', 'PHP Laravel', 'PostgreSQL', 'Heroku'],
    title: '',
    description: '',
    link: 'link',
  },
  // {
  //   imageLink:
  //     'https://s3-ap-southeast-2.amazonaws.com/ken-huang.me/images/project-placeholder.jpg',
  //   tags: ['React', 'Redux', 'Telegram Bot API'],
  //   title: 'Telegram Chat Bot - Todo List',
  //   html: 'A simple To-do List web app, which is also integrated with the <a href="https://core.telegram.org/bots/api" target="_blank" rel="noreferrer noopener">Telegram Bot API</a> allowing usage through the Telegram application ',
  // },
  lc: {
    imageLink:
      'link.jpg',
    tags: ['Wordpress', 'WooCommerce'],
    title: '',
    link: 'link',
    description: '',
  },
}



// WEBPACK FOOTER //
// ./src/consts/projects.js